(function () {
  // COA piece checker. Validates ?piece= against the edition size
  // before showing a certificate. Anything that is not a whole number
  // from 1 to the edition size shows "Not found in the registry".
  var params = new URLSearchParams(window.location.search);
  var raw = params.get('piece');
  if (raw === null) return;

  var section = document.getElementById('coa-section');
  var cards = document.getElementById('resin-cards-section');
  var pieceLine = document.getElementById('coa-piece-line');
  var pieceNum = document.getElementById('coa-piece-num');
  var seal = section ? section.querySelector('.coa-seal-inner') : null;
  var serial = section ? section.querySelector('.coa-serial') : null;
  var sealBox = section ? section.querySelector('.coa-wax-seal') : null;

  var qtyMatch = pieceLine ? pieceLine.textContent.match(/of\s+(\d+)/) : null;
  var qty = qtyMatch ? parseInt(qtyMatch[1], 10) : 0;

  var clean = String(raw).trim();
  var valid = /^[0-9]{1,4}$/.test(clean);
  var n = valid ? parseInt(clean, 10) : NaN;
  if (!(n >= 1 && qty > 0 && n <= qty)) valid = false;

  if (section) {
    section.style.display = 'block';
    section.setAttribute('data-coa-state', valid ? 'verified' : 'invalid');
  }
  if (cards) cards.style.display = 'none';

  if (valid) {
    if (pieceLine) pieceLine.textContent = 'Verified Piece ' + n + ' of ' + qty;
    if (pieceNum) pieceNum.textContent = String(n).padStart(3, '0');
  } else {
    if (pieceLine) pieceLine.textContent = 'Not found in the registry';
    var note = pieceLine ? pieceLine.parentNode : null;
    if (note && note.childNodes.length > 1) {
      note.lastChild.textContent = ' This number does not match a registered piece in this edition. If you tapped a chip and see this, please contact Khrysalis Studios.';
    }
    if (serial) serial.style.display = 'none';
    if (seal) seal.textContent = '?';
    if (sealBox) sealBox.style.filter = 'grayscale(1)';
  }
})();
